import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { adminDashboardDetailsApi } from "../../../utils/ApiEndpointFunctions";
import Spinwheel from "../../common/Spinwheel";
import { useAdminContext } from "../../../context/adminContext";
import { useNavigate } from "react-router-dom";
import MetricCard from "./components/MetricCard";
import RidesEarningChart from "./components/RidesEarningChart";

export default function RidesDashboard() {
  const [loader, setLoader] = useState(false)
  const [details, setDetails] = useState({})
  const { setAdminDetail, adminDetail } = useAdminContext();
  const navigate = useNavigate()

  const getDashboardDetails = async () => {
    try {
      setLoader(true);
      const res = await adminDashboardDetailsApi();
      setDetails(res?.data?.data);
      setLoader(false);
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      setLoader(false);
    }
  }

  // useEffect(() => {
  //   if (adminDetail?.role === "superAdmin") {
  //     getDashboardDetails();
  //   } else {
  //     navigate("/partners?type=all")
  //   }

  // }, [adminDetail?.role])

  const metrics = [
    {
      label: "Total Rides",
      value: 0,

      background: "#E3F5FF",
    },
    {
      label: "Total Drivers",
      value: 0,

      background: "#E5ECF6",
    },
    {
      label: "Total Cars",
      value: 0,

      background: "#E3F5FF",
    },
    {
      label: "Total Complete Rides",
      value: 0,

      background: "#E5ECF6",
    },
    {
      label: "Total Cancel Rides",
      value: 0,

      background: "#E3F5FF",
    },
    {
      label: "Application Drivers",
      value: 0,

      background: "#E5ECF6",
    },
    {
      label: "Reject Drivers",
      value: 0,

      background: "#E3F5FF",
    },
    {
      label: "Total Vehicles",
      value: 0,

      background: "#E5ECF6",
    },
  ]


  return (
    <>
      <div className="main-content">

        <div className="container-fluid ">
          {
            loader ? <Spinwheel /> :
              <>
                <div className="mt-2 g-4 card rounded-2">

                  <div className="metric_row">

                    {metrics.map((metric, index) => (
                      <MetricCard
                        key={index}
                        label={metric.label}
                        value={metric.value}
                        background={metric.background}
                      />
                    ))}
                  </div>


                  <div className="row">
                    <RidesEarningChart />
                  </div>
                </div>
              </>
          }

        </div>
      </div>
    </>
  );
}
